// extracted by mini-css-extract-plugin
export default {"container":"Products_container__Iv124","products":"Products_products__oVCwj","menu":"Products_menu__dC0cw","list":"Products_list__ySl6y","product":"Products_product__tYvMe"};